import { render, staticRenderFns } from "./ModalAdicionarIniciativa.vue?vue&type=template&id=65336bde&scoped=true"
import script from "./ModalAdicionarIniciativa.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarIniciativa.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarIniciativa.vue?vue&type=style&index=0&id=65336bde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65336bde",
  null
  
)

export default component.exports